import { HUB_PATH, WORD_APP_PATH, DOZEN_APP_PATH } from '../config';

export const ADMIN_SECTIONS = [
  { key: 'word', to: `${WORD_APP_PATH}/admin`, label: 'Слово Дня' },
  { key: 'dozen', to: `${DOZEN_APP_PATH}/admin`, label: 'Дюжина' }
];

const EXIT_KEY = 'adminExitTo';
const LAST_SECTION_KEY = 'adminLastSection';

const isAdminPath = (path) => ADMIN_SECTIONS.some((s) => s.to === path);

function readStorage(storage, key) {
  try {
    return window[storage].getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(storage, key, value) {
  try {
    window[storage].setItem(key, value);
  } catch {
    // Private mode: navigation still works, just without memory.
  }
}

/** Remember the page to return to when leaving the admin area. */
export function rememberAdminExit(path) {
  if (!isAdminPath(path)) writeStorage('sessionStorage', EXIT_KEY, path);
}

export function adminExitPath() {
  const saved = readStorage('sessionStorage', EXIT_KEY);
  return saved && !isAdminPath(saved) ? saved : HUB_PATH;
}

export function rememberAdminSection(key) {
  writeStorage('localStorage', LAST_SECTION_KEY, key);
}

/** Admin page to open: the current game's, else the last one used, else Слово Дня. */
export function adminEntryPath(appKey) {
  const key = appKey || readStorage('localStorage', LAST_SECTION_KEY);
  return (ADMIN_SECTIONS.find((s) => s.key === key) || ADMIN_SECTIONS[0]).to;
}
